import React, { useRef, useState } from "react";
import WebView from "react-native-webview";
import ActivityIndicator from "../components/ActivityIndicator";
import Screen from "../components/Screen";
import settings from "../config/settings";
// import WebView from 'react-native-web-webview'

function PaymentScreen({ navigation, route }) {
  const record = route.params.user;
  const [loading, setLoading] = useState(false);

  const webView = useRef();

  const handleNavigationState = (newNavState) => {
    // console.log(newNavState, "fsj");
    if (newNavState.url.includes("success.php")) {
      // navigation.pop(1);
      // route.params.returnData(newNavState.url);
      navigation.navigate("Final", { paySuccess: newNavState.url });
    }
  };

  // if (window.location.href.includes("success.php")) {
  //   navigation.navigate("Final", { paySuccess: window.location.href });
  // }

  const finalUrl =
    settings.apiUrl +
    record.type +
    "_web.php?submission_id=" +
    record.record_id +
    "&access_token=" +
    record.token +
    "&payment_package=" +
    record.package;
  console.log("oit", finalUrl);
  return (
    <Screen>
      <WebView
        //   style={styles.container}
        originWhitelist={["*"]}
        renderLoading={() => <ActivityIndicator />}
        source={{ uri: finalUrl }}
        ref={webView}
        cacheEnabled={false}
        onNavigationStateChange={handleNavigationState}
        onLoadStart={() => setLoading(true)}
        onLoad={() => setLoading(false)}
      />
      {/* <ActivityIndicator visible={loading} /> */}
    </Screen>
  );
}

export default PaymentScreen;
